module.exports = __webpack_public_path__ + "static/media/personal_folder_p2_1.e2c8a58b.png";